<ng-container>
  <ng-container [ngSwitch]="snapshotParams.status">
    <ng-container *ngSwitchCase="DistributorTabStatus.REGISTERED" [ngTemplateOutlet]="registeredViewTpl"></ng-container>
    <ng-container *ngSwitchCase="DistributorTabStatus.PENDING" [ngTemplateOutlet]="pendingViewTpl"></ng-container>
    <ng-container *ngSwitchCase="DistributorTabStatus.REJECT" [ngTemplateOutlet]="rejectViewTpl"></ng-container>
  </ng-container>
</ng-container>

<ng-template #registeredViewTpl>
  <ng-container [ngTemplateOutlet]="scopeTpl"></ng-container>
  <ng-container [ngTemplateOutlet]="distributorDetailTpl"></ng-container>
  <div class="overflow-hidden">
    <div class="row">
      <div class="col-12 col-lg-6">
        <!-- pemilik usaha -->
        <ng-container [ngTemplateOutlet]="ownerTpl"></ng-container>
      </div>
      <div class="col-12 col-lg-6">
        <!-- pengelola usaha -->
        <ng-container [ngTemplateOutlet]="managerTpl"></ng-container>
      </div>
    </div>
  </div>
  <ng-container [ngTemplateOutlet]="businessInfoTpl"></ng-container>
  <ng-container [ngTemplateOutlet]="npwpInfoTpl"></ng-container>
  <ng-container [ngTemplateOutlet]="supplierTpl"></ng-container>
  <ng-container [ngTemplateOutlet]="branchTpl"></ng-container>
</ng-template>

<ng-template #pendingViewTpl>
  <ng-container [ngTemplateOutlet]="IsPendingTabNonActive ? pendingTabNonActive : defaultPendingTpl"></ng-container>

  <ng-template #pendingTabNonActive>
    <ng-container [ngTemplateOutlet]="distributorDetailTpl"></ng-container>
    <div class="overflow-hidden">
      <div class="row">
        <div class="col-12 col-lg-6">
          <!-- pemilik usaha -->
          <ng-container [ngTemplateOutlet]="ownerTpl"></ng-container>
        </div>
        <div class="col-12 col-lg-6">
          <!-- pengelola usaha -->
          <ng-container [ngTemplateOutlet]="managerTpl"></ng-container>
        </div>
      </div>
    </div>
    <ng-container [ngTemplateOutlet]="receivableInfoTpl"></ng-container>
    <ng-container [ngTemplateOutlet]="lastSalesOrderTpl"></ng-container>
    <ng-container [ngTemplateOutlet]="documentNonActiveTpl"></ng-container>
  </ng-template>

  <ng-template #defaultPendingTpl>
    <ng-container [ngTemplateOutlet]="scopeTpl"></ng-container>
    <ng-container [ngTemplateOutlet]="distributorDetailTpl"></ng-container>
    <ng-container [ngTemplateOutlet]="ownerTpl"></ng-container>
    <ng-container [ngTemplateOutlet]="managerTpl"></ng-container>
    <ng-container [ngTemplateOutlet]="businessInfoTpl"></ng-container>
    <ng-container
      [ngTemplateOutlet]="isPendingRegistrationFinance() ? pendingRegistrationFinanceTpl : defaultPendingRegistrationTpl"></ng-container>
  </ng-template>
</ng-template>

<ng-template #rejectViewTpl>
  <ng-container [ngTemplateOutlet]="scopeTpl"></ng-container>
  <ng-container [ngTemplateOutlet]="distributorDetailTpl"></ng-container>
  <ng-container [ngTemplateOutlet]="ownerTpl"></ng-container>
  <ng-container [ngTemplateOutlet]="managerTpl"></ng-container>
  <ng-container [ngTemplateOutlet]="businessInfoTpl"></ng-container>
  <ng-container [ngTemplateOutlet]="npwpInfoTpl"></ng-container>
  <ng-container [ngTemplateOutlet]="supplierTpl"></ng-container>
  <ng-container [ngTemplateOutlet]="branchTpl"></ng-container>
</ng-template>

<ng-template #scopeTpl>
  <!-- cakupan -->
  <app-card-tab-section [data]="bodyScope"/>
</ng-template>

<ng-template #distributorDetailTpl>
  <!-- cakupan -->
  <app-card-tab-section [data]="bodyDistributorDetail"/>
</ng-template>

<ng-template #ownerTpl>
  <!-- pemilik usaha -->
  <app-card-tab-section [data]="bodyOwner"/>
</ng-template>

<ng-template #managerTpl>
  <!-- pengelola usaha -->
  <app-card-tab-section [data]="bodyManager"/>
</ng-template>

<ng-template #businessInfoTpl>
  <!-- informasi usaha -->
  <app-card-tab-section [data]="bodyBusinessInfo"/>
</ng-template>

<ng-template #npwpInfoTpl>
  <!-- informasi npwp -->
  <app-card-tab-section [data]="bodyNpwpInfo"/>
</ng-template>

<ng-template #supplierTpl>
  <!-- informasi supplier -->
  <app-card-tab-section [data]="bodySupplier"/>
</ng-template>

<ng-template #branchTpl>
  <!-- cabang usaha -->
  <app-card-tab-section [data]="bodyBusinessBranch"/>
</ng-template>

<ng-template #pendingRegistrationFinanceTpl>
  <app-card-tab-section [data]="bodyCreditCeilingGranted"/>
  <app-card-tab-section [data]="bodySaleTarget"/>
  <app-card-tab-section [data]="bodyCreditBilling"/>
</ng-template>

<ng-template #defaultPendingRegistrationTpl>
  <ng-container [ngTemplateOutlet]="npwpInfoTpl"></ng-container>
  <ng-container [ngTemplateOutlet]="supplierTpl"></ng-container>
  <ng-container [ngTemplateOutlet]="branchTpl"></ng-container>
</ng-template>

<ng-template #receivableInfoTpl>
  <app-card [cardClasses]="'mb-8'" [cardBodyClasses]="'pt-0'" [header]="true">
    <!-- header start -->
    <ng-container cardHeader>
      <h5 class="fw-bolder d-flex w-100 align-items-center mb-0">
        <span>{{ bodyReceivableInfo.value.cardTitle }}</span>
      </h5>
    </ng-container>

    <!-- body start -->
    <ng-container cardBody>
      <app-section-loader *ngIf="isLoading | async"/>
      <ng-container *ngIf="Object.keys(DetailInformation).length > 0;">
        <div class="my-4">
          <span class="fw-bolder">Informasi Plafon</span>
          <div class="row my-2">
            <div class="col-12 col-lg-3 my-2 text-gray-700">Plafon Kredit</div>
            <div class="col-12 col-lg-9 my-2">
              : {{ toRupiah(DetailInformation?.information_receivable?.information_ceiling?.credit_ceiling ?? 0) }}
            </div>
          </div>
          <div class="row my-2">
            <div class="col-12 col-lg-3 my-2 text-gray-700">Total Piutang</div>
            <div class="col-12 col-lg-9 my-2">
              : {{ toRupiah(DetailInformation?.information_receivable?.information_ceiling?.total_receivable ?? 0) }}
            </div>
          </div>
          <div class="row my-2">
            <div class="col-12 col-lg-3 my-2 text-gray-700">Jangka waktu Kredit</div>
            <div class="col-12 col-lg-9 my-2">
              : {{ DetailInformation?.information_receivable?.information_ceiling?.credit_term }}
            </div>
          </div>
        </div>
        <div class="my-4">
          <span class="fw-bolder">Tagihan Belum Jatuh Tempo</span>
          <div class="row my-2">
            <div class="col-12 col-lg-3 my-2 text-gray-700">Total Tagihan</div>
            <div class="col-12 col-lg-9 my-2">
              : {{ toRupiah(DetailInformation?.information_receivable?.not_due_total ?? 0) }}
            </div>
          </div>
        </div>
        <div class="my-4">
          <span class="fw-bolder">Tagihan Jatuh Tempo</span>
          <div class="row my-2">
            <div class="col-12 col-lg-3 my-2 text-gray-700">Total Tagihan</div>
            <div class="col-12 col-lg-9 my-2">
              : {{ toRupiah(DetailInformation?.information_receivable?.over_due_total ?? 0) }}
            </div>
          </div>
          <div class="row my-2" *ngFor="let item of DetailInformation?.information_receivable?.over_due">
            <div class="col-12 col-lg-3 my-2 text-gray-700">{{ item.name }}</div>
            <div class="col-12 col-lg-9 my-2">: {{ toRupiah(item.value) }}</div>
          </div>
        </div>
        <div class="my-4">
          <span class="fw-bolder">Bilyet Giro</span>
          <div class="row my-2">
            <div class="col-12 col-lg-3 my-2 text-gray-700">Total Bilyet Giro</div>
            <div class="col-12 col-lg-9 my-2">
              : {{ toRupiah(DetailInformation?.information_receivable?.bilyet_giro ?? 0) }}
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </app-card>
</ng-template>

<ng-template #lastSalesOrderTpl>
  <app-last-sales-order [title]="'Informasi Sales Order'"></app-last-sales-order>
</ng-template>

<ng-template #documentNonActiveTpl>
  <app-card [cardClasses]="'my-8'" [cardBodyClasses]="'pt-0'" [header]="true">
    <!-- header start -->
    <ng-container cardHeader>
      <h5 class="fw-bolder d-flex w-100 align-items-center mb-0">
        <span>Dokumen Penonaktifan</span>
      </h5>
    </ng-container>

    <ng-container cardBody>
      <div class="row">
        <div class="col-12 col-lg-6">
          <app-document-preview [data]="documentNonActive"></app-document-preview>
        </div>
      </div>
    </ng-container>
  </app-card>
</ng-template>
